import React from "react";
import TooltipInfo from "../tooltip-info";

const FormSwitch = (props) => {
  const { label, checkedValue, onChange, labelInfo, ...rest } = props;

  const renderLabel = React.useCallback(() => {
    if (!label) return null;
    return (
      <div className="booking-form__label">
        <label className="form-label user-select-none d-flex align-items-center">
          {label}
          {labelInfo && (
            <TooltipInfo title={labelInfo} />
          )}
        </label>
      </div>
    );
  }, [label]);

  const handleChange = (e) => {
    const { checked } = e.target;
    onChange?.(checked);
  };

  return (
    <div className="booking-form__row">
      <div className="booking-form__row">
        {renderLabel()}

        <div className="booking-form__control">
          <div className="form-switch">
            <input
              checked={checkedValue || ""}
              className="form-check-input"
              type="checkbox"
              onChange={handleChange}
              {...rest}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(FormSwitch);
